import { CompanyRegistrationFormValues } from 'feature/company/types/CompanyRegistrationForm'

const FORM_KEY = 'companyRegistrationForm'
const STEP_KEY = 'companyRegistrationStep'
const SAME_AS_LEGAL_KEY = 'companyRegistrationSameAsLegal'
const EMAIL_KEY = 'companyRegistrationEmail'
const PHONE_KEY = 'companyRegistrationPhone'
const DOCS_FILES_KEY = 'companyRegistrationDocFiles'

export const companyRegistrationStorage = {
  saveForm(data: CompanyRegistrationFormValues) {
    sessionStorage.setItem(FORM_KEY, JSON.stringify(data))
  },

  loadForm(): CompanyRegistrationFormValues | null {
    try {
      const raw = sessionStorage.getItem(FORM_KEY)
      return raw ? JSON.parse(raw) : null
    } catch {
      return null
    }
  },

  saveStep(step: 1 | 2) {
    sessionStorage.setItem(STEP_KEY, String(step))
  },

  loadStep(): 1 | 2 {
    try {
      return sessionStorage.getItem(STEP_KEY) === '2' ? 2 : 1
    } catch {
      return 1
    }
  },

  loadEmail(): string {
    return sessionStorage.getItem(EMAIL_KEY) || ''
  },

  saveDocFiles(files: Record<string, unknown[]>) {
    sessionStorage.setItem(DOCS_FILES_KEY, JSON.stringify(files))
  },

  loadDocFiles(): Record<string, unknown[]> {
    try {
      const raw = sessionStorage.getItem(DOCS_FILES_KEY)
      return raw ? JSON.parse(raw) : {}
    } catch {
      return {}
    }
  },

  clearDocFiles() {
    sessionStorage.removeItem(DOCS_FILES_KEY)
  },

  clear() {
    ;[
      FORM_KEY,
      STEP_KEY,
      SAME_AS_LEGAL_KEY,
      EMAIL_KEY,
      PHONE_KEY,
      DOCS_FILES_KEY,
    ].forEach(key => sessionStorage.removeItem(key))
  },
}
